import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Country } from '@afterpaytouch/portal-api/types'
import { getCheckout } from '../index'

const allCountries = Object.values(Country)

interface CountryState {
  initial: Country | null
  merchant: Country[]
}

export const countryInitialState: CountryState = {
  initial: null,
  merchant: [],
}

const slice = createSlice({
  name: 'country',
  initialState: countryInitialState,
  reducers: {
    setCountry(state: CountryState, action: PayloadAction<Country>) {
      state.initial = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCheckout.fulfilled, (state, action) => {
      state.merchant = action.payload.merchant.supportedCountries ?? (state.initial == null ? allCountries : [state.initial])
    })
  },
})

export const { setCountry } = slice.actions

export default slice.reducer
